import React from 'react'
import cn from 'classnames'

import { Back } from '../Back'

import styles from './styles.module.scss'

const ContractAndMoney = () => (
	<article className={styles.article}>
		<Back />
		<h1 className={styles.heading}>Подписание документов и поступление денег на счёт</h1>

		<nav className={styles.nav}>
			<ul>
				<li className={styles.navItem}>
					<a className={styles.link} href='#how-to-sign'>
						Как проходит подписание документов?
					</a>
				</li>
				<li className={styles.navItem}>
					<a className={styles.link} href='#what-form'>
						В какой форме будет заключён договор?
					</a>
				</li>
				<li className={styles.navItem}>
					<a className={styles.link} href='#how-long'>
						Сколько длится подписание документов?
					</a>
				</li>
				<li className={styles.navItem}>
					<a className={styles.link} href='#cash'>
						Как быстро деньги поступят на счёт?
					</a>
				</li>
			</ul>
		</nav>

		<h3 id='how-to-sign' className={styles.title}>
			Как проходит подписание документов?
		</h3>
		<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
			Подписание документов состоит из нескольких шагов.
		</p>

		<ul>
			<li>
				<p className={styles.paragraph}>
					<b>Шаг 1.</b> Наш представитель приезжает на объект залога с полным пакетом документов для
					каждого участника сделки.
				</p>
			</li>
			<li>
				<p className={styles.paragraph}>
					<b>Шаг 2.</b> Он фотографирует объект залога: делает снимки всех комнат.
				</p>
			</li>
			<li>
				<p className={styles.paragraph}>
					<b>Шаг 3.</b> Мы подписываем документы в печатном виде. Каждый участник сделки получает
					пакет документов на руки.
				</p>
			</li>
			<li>
				<p className={styles.paragraph}>
					<b>Шаг 4.</b> Мы выпускаем электронную подпись для заёмщика и залогодателя.
				</p>
			</li>
			<li>
				<p className={styles.paragraph}>
					<b>Шаг 5.</b> Участники сделки подписывают электронный пакет документов через личный
					кабинет и приложение myDSS.
				</p>
			</li>
			<li>
				<p className={styles.paragraph}>
					<b>Шаг 6.</b> Мы формируем электронное заявление на регистрацию обременения в Росреестр.
					Залогодатель подписывает его с помощью электронной подписи.
				</p>
			</li>
		</ul>

		<p className={styles.paragraph}>
			Затем мы отправляем заявление в Росреестр. Для этого не нужно ехать в МФЦ — весь процесс
			проходит удалённо, потому что мы заключили соглашение с Росреестром и подключились к их
			системе.
		</p>

		<h3 id='what-form' className={styles.title}>
			В какой форме будет заключён договор?
		</h3>
		<p className={styles.paragraph}>Договор заключается в печатной и электронной формах.</p>

		<h3 id='how-long' className={styles.title}>
			Сколько длится подписание документов?
		</h3>
		<p className={styles.paragraph}>
			Для подписания документов и подачи заявления на регистрацию обременение понадобится от 45
			минут до 2-х часов. Вам не придётся тратить весь день на сделку, не нужно приезжать к нам в
			офис и ехать в МФЦ — наши сотрудники приедут к вам с готовым пакетом документов.
		</p>
		<h3 id='cash' className={styles.title}>
			Как быстро деньги поступят на счёт?
		</h3>
		<p className={styles.paragraph}>
			Чаще всего деньги поступают на счёт не позднее 1–2 рабочих дней после регистрации сделки в
			Росреестре.{' '}
		</p>
		<p className={styles.paragraph}>
			Сама регистрация обременения обычно занимает не больше 3-х дней.
		</p>
	</article>
)

export default ContractAndMoney
